import classes from "../../TwoFactorAuth.scss";
import {getLocalizedStringstwo} from'../../twoFactorAuthenticationStrings';
import SceTextBox from "../../common/TwoFactorVerifyTextBox";
import RadioGroup from "../../common/RadioGroup";
import SceButton from  "../../../../../Common/CommonComponents/sceButton";

function PhoneStepTwo(props) {
    let strings = getLocalizedStringstwo('TwoFactorAuthentication');
    let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    const radioButton = <RadioGroup setName={'phoneType'} options={props.phoneType.labels} type='radio' validStyle={props.phoneType.validStyle} radioOutLineFlag={props.phoneType.outlineStyle} selectedOptions={props.phoneType.value} onClick={props.phoneTypeHandler} />;
    const resendExceedMsg =props.resendExceedMsg ? 
    <div>
        <div className={["sce-content-row",'sce-center-alg'].join(" ")}><a className={classes.disabledSendCode}> {strings.resendCode}</a> </div>
             <div className={classes.errorContainer}>
            <span><img src={warningImg} alt="Warning Image" /></span>
            <span className={classes.errMsg}> {props.resendExceedMsg}</span>
            </div>
        </div>
        :
        <div className={["sce-content-row",'sce-center-alg',classes.centeraligned].join(" ")}> <a className={classes.sendCode}  href="JavaScript:void(0)" onClick={props.resendCodeHandle}>  {strings.resendCode}</a></div>;
    const invalidCodeErrormsg =  props.invalidCodeError ? <div className={classes.invalidCodeErrorSection}> <img src={warningImg} alt="invalidCoderror" /><span className={classes.invalidCodeErrormsg}>  {strings.invalidCodeError}</span></div>: '';
    const tryAgain = !props.resendSuccess ?
        <div className={classes.errorContainer}>
            <span> <img src={warningImg} alt="Warning Image" /> </span>
            <span className={[classes.marginRight, classes.errMsg].join(" ")}>
                {strings.tryAgain}
        </span>
    </div>
    : null;
    return (
        <div className={props.stepTwo==='voice'? classes.stepTwoVoice:classes.stepTwoText}>
        <div className={classes.enterVerifyCode}>
            <div className={classes.enterVerifyCodeContainer}>
                    <div className={[classes.verifyLogIn, classes.verifyLogInFlex, 'sce-center-alg'].join(" ")}> {strings.enterVerificationCode}
                        <div className={[classes.verifyAddress, "sce-space-xs"].join(" ")}> {props.maskedValue}
                        </div>
                    </div>
                    <div className={[classes.subTextCodeReceived].join(" ")}>  {props.isCall ? strings.callVerification:strings.textVerification}
                        <div className={["sce-content-row",classes.verificationCode,classes.verificationCodeFontSize].join(" ")}> {strings.verificationCode}
                            <div className={classes.verificationCodeMarginTop}>
                                <SceTextBox
                                    type={props.isCall ? "verificationCode" : "verificationCodeSms"}
                                    id={'verificationCodesms'}
                                    validator={app.appUtil.validator}
                                    maxLength={props.pinLength}
                                    onChangeVerifyHandler={props.onChangeHandler}
                                />

                            </div>
                            {invalidCodeErrormsg}
                            {props.isCall  &&   <div className={classes.phoneTypes}> {strings.phonetype}
                            <div className={classes.phoneTypesLeftMargin}>
                                    {radioButton}
                                </div>
                            </div>}
                            <div className={['sce-center-alg',!props.isCall ? "sce-space-s" : '',classes.verifyBtn,classes.verifyBtnMarginTop].join(" ")}> 
                            <SceButton id='VerfiyCode' isDisabled={(props.disableVerifyBtn) ? true : false} buttonType={props.disableVerifyBtn  ? 'sceDisabled' : 'primary'} value={strings.verify} onClick={props.verifyCodeHandler} />
                            </div>
                            {resendExceedMsg}
                            {tryAgain}
                        </div>
                    </div>
                </div>
        </div>
        </div>
    );
}

export default PhoneStepTwo;
